export function round_amount (amount) {
    if(!amount) return
    return amount.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
}

export const removeNull = obj => Object.fromEntries(Object.entries(obj).filter(([_, v]) => {return (!!v && v !== 'false' && v.length > 0)}));